<template>
  <div>
    <div class="flex-c mt100">
      <img src="@/assets/images/success.png" show-menu-by-longpress alt />
      <span class="f36 color-333 fb ml10">{{title}}</span>
    </div>
    <div class="flex-c flex-dc f26 color-A mb200 mt100">
      <!-- <img class="img-box" :src="dataList.teacherma" alt=""> -->
      <span f28 color-6>优惠券已存入+86 {{mobile}} 账号</span>
      <span class="mt10 f28 color-6">打开更新学堂APP，开始学习</span>
    </div>
    <!-- <div class="footer-short mb50">去赠送</div> -->
    <div class="footer-btn-mian" @click="openApp">下载App</div>
  </div>
</template>
<script>
import { getShareInfo } from '@/utils/storage'
import { wxShare } from '@/utils/wx-config'
export default {
  data() {
    return {
      id: '',
      type: 1,
      dataList: [],
      dataInfo: [],
      jumpType: '',
      goodsId: '',
      mobile: '',
      title: '',
    }
  },
  created() {
    this.mobile = this.$route.query.mobile
    this.title = this.$route.query.title
  },
  mounted() {
    let shareInfo = getShareInfo()
    wxShare({
      shareInfo,
    })
  },
}
</script>

<style lang="less" scoped>
.img-box {
  width: 200px;
  height: 200px;
  margin: 100px 0 26px 0;
}
</style>
